"use strict";const i=require("styled-components").css`
    .equal-height-JlocK {
        display: block;
        overflow: hidden;
        transition-property: height;
    }
    &.DXIconListGrid {
        position: relative;
        width: 100%;
        max-width: 100%;
    }
    .DXIconListGrid-heading {
        position: relative;
        font-family: 'source-sans-pro', sans-serif;
        color: ${({theme:i})=>i.colors.common.dark};
        padding-top: 15px;
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 24px;
        overflow: hidden;

        @media (max-width: 830px) {
            padding-left: 46px;
        }
    }
    .DXIconListGrid-heading:after {
        content: '';
        position: absolute;
        top: 0;
        width: 100%;
        height: 1px;
        background: #e4e5e7;
        @media (max-width: 830px) {
            display: none;
        }
    }
    .DXIconListGrid-item-list {
        gap: 60px;
        @media (max-width: 830px) {
            flex-wrap: wrap;
            gap: 40px;
        }
    }
    .DXIconListGrid-item {
        flex: 0 1 33.3333%;
        padding: 0px;
        @media (max-width: 830px) {
            flex: 0 1 100%;
            padding: 0px 0px 0px 0px;
        }
    }
    .DXIconListGrid-sub-item {
        width: 100%;
    }
    .DXIconListGrid-sub-item-heading {
        margin: 0;
    }
    .DXIconListGrid-heading {
        display: flex;
        margin-bottom: 60px;
    }
    .DXIconListGrid-item-heading {
        margin: 0px 0px 30px;
        font-family: 'source-sans-pro', sans-serif;
        color: #25292d;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        padding-left: 46px;
        position: relative;
        @media (max-width: 830px) {
            padding-bottom: 10px;
            overflow: hidden;
        }
    }
    .DXIconListGrid-item-heading:after {
        @media (max-width: 830px) {
            content: '';
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 1px;
            left: 46px;
            background: #e4e5e7;
        }
    }
    .DXIconListGrid-icon {
        position: relative;
        display: flex;
        justify-content: center;
        flex: 0 0 30px;
        padding-top: 5px;
    }
    .DXIconListGrid-sub-item-list {
        position: relative;
    }
    .DXIconListGrid-item:not(:last-child)
        > .DXIconListGrid-sub-item-list:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: -30px;
        height: 100%;
        width: 1px;
        background: #e4e5e7;
        @media (max-width: 830px) {
            display: none;
        }
    }
    .equal-height-JlocK {
        width: 100%;
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
